import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import SearchInput from '../../../../components/core/Input/SearchInput';
import { IProductItem } from '../../../../interface/IProduct';
import SelectInput from '../../../../components/core/Input/SelectInput/SelectInput';
import RowButton from '../../../../components/core/Button/RowButton';
import Paginate from '../../../../components/core/Pagination/Paginate';
import { GiBroom } from 'react-icons/gi';
import Cookies from 'universal-cookie';
import DesktopSidebar from '../../../../components/Sidebar/SidebarContent';
import ShimmerBreadcrumb from '../../../../components/shimmer/ShimmerBreadcrumb';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';
import RequestService from '../../../../services/RequestService';
import { BiImageAdd } from 'react-icons/bi';
import { VscListTree } from 'react-icons/vsc';
import { CiEdit } from 'react-icons/ci';
import { AiOutlineDelete } from 'react-icons/ai';
import { ISubCategory } from '../../../../interface/ISubCategory';
import clsx from 'clsx';

const SubCategoryList = () => {
  const { id } = useParams();
  const cookies = new Cookies(null, { path: '/' });
  const [loading, setLoading] = useState(false);

  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const [subs, setSubs] = useState<ISubCategory[]>([]);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const fetchSubCategories = async (number?: number) => {
    let params = '';
    params += '?';
    params += `page=${number}`;

    setLoading(true);
    const requestService = new RequestService(
      `/api/v1/admin/category/${id}/sub`
    );
    const result = await requestService.get(params);
    setSubs(result.data.subs);
    // setItems(result.data.items);
    // setPage(result.data.pagination['current-page']);
    // setTotal(result.data.pagination.count);
    // setPageItems(result.data.pagination['per-page']);
    // setBreadcrumbs(result.data.breadcrumb);
    // setLoading(false);
  };

  const onProductActivateStatusHandler = async (
    subId: number
  ): Promise<void> => {
    const requestService = new RequestService(
      `/api/v1/admin/category/${id}/sub/${subId}/activate`
    );
    const data = await requestService.post();
    setSubs(data.data.sub);
  };

  useEffect(() => {
    fetchSubCategories().catch((error) => {
      console.log(error);
    });
  }, []);

  // filter
  const onSubmitFilterHandler = async (e: any) => {
    e.preventDefault();

    let params = '';
    params += '?';
    // params += `search=${search}`;

    try {
      const res = await fetch(
        BASE_URL + `/api/v1/admin/product/${id}/items${params}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cookies.get('token'),
          },
        }
      );

      if (res.status === 200) {
        const data = await res.json();
        // setSubs(data.data.items);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="w-[95%] mx-auto flex-row gap-2">
      <div className="flex justify-between align-middle my-10">
        <div>
          {/* {loading ? (
            <ShimmerBreadcrumb items={3} />
          ) : (
            <Breadcrumb breadcrumbs={breadcrumbs} />
          )} */}
        </div>
        <div className=" my-10">
          <Link
            className="border border-amber-300 rounded-lg text-white p-6 hover:bg-amber-200 hover:text-black"
            to={`/category/${id}/sub/create`}
          >
            افزودن
          </Link>
        </div>
      </div>
      <div className="bg-sky-950 rounded-t-lg my-2">
        <form id="filter" onSubmit={onSubmitFilterHandler}>
          <div className="py-5">
            <div className="float-end mx-3 border border-amber-300 rounded-md p-1 hover:bg-amber-200 hover:cursor-pointer">
              <GiBroom size={25} color="fff" />
            </div>
            <SearchInput onChangeHandler="" />
            <div className="md:grid md:grid-cols-3 md:gap-1">
              {/* <SelectInput
                className=""
                title="رنگ"
                list={colors}
                onChangeHandler={getColorsHandler}
                message=""
                value=""
              />
              <SelectInput
                className=""
                title="نوع جنس"
                list={materials}
                onChangeHandler={getMaterialHandler}
                message=""
                value=""
              />
              <SelectInput
                className=""
                title="خدمات پس‌از فروش"
                list={services}
                onChangeHandler={getMaterialHandler}
                message=""
                value=""
              />
              <SelectInput
                className=""
                title="وضعیت"
                list={statuses}
                onChangeHandler={getStatusHandler}
                message=""
                value=""
              /> */}
            </div>
          </div>
          <RowButton
            title="فیلتر"
            type="submit"
            form="filter"
            className={'bg-cyan-800 hover:bg-cyan-700 text-white'}
          />
        </form>
      </div>
      <div className="rounded-lg">
        <table className="w-full mx-auto text-sm text-left rtl:text-right text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" className="px-6 py-3 text-right">
                عنوان
              </th>
              <th scope="col" className="px-6 py-3 text-left">
                عملیات
              </th>
            </tr>
          </thead>
          <tbody>
            {subs &&
              subs.map((sub) => (
                <tr key={sub.id} className="bg-white border-b hover:bg-gray-50">
                  <td className="px-6 py-4">
                    <div className="text-base font-semibold text-gray-900">
                      {sub.title}
                    </div>
                  </td>

                  <td className="px-6 py-4 flex items-center justify-end flex-wrap gap-3">
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        checked={sub.activate}
                        onChange={() => onProductActivateStatusHandler(sub.id)}
                        type="checkbox"
                        className="sr-only peer"
                      />

                      <div
                        className={clsx(
                          'relative w-9 h-5 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full after:content-[""] after:absolute after:top-[2px] after:end-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all',
                          {
                            'bg-[#3C5CAA]': sub.activate,
                            'bg-gray-400': !sub.activate,
                          }
                        )}
                      />
                    </label>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {/* {total >= 24 && (
          <Paginate
            current={page}
            onChange={(number: number) => fetchSubCategories(number)}
            total={total}
            pageSize={pageItems}
            className="my-2 items-center flex justify-center ltr"
          />
        )} */}
      </div>
    </div>
  );
};

export default SubCategoryList;
